import { getPopupMessage } from './Popup.service'

const defaultState = {
  popupNotificationMessage: ''
}

const getters = {
  popupNotificationMessage: (state) => state.popupNotificationMessage
}

const mutations = {
  setPopupNotificationMessage: (state, message) => {
    state.popupNotificationMessage = message
  }
}

const actions = {
  getPopupMessage: async ({ commit }) => {
    const message = await getPopupMessage()
    commit('setPopupNotificationMessage', message)
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
